export const MondayIframe = () => {
  return (
    <iframe
      title="Monday Dashboard"
      src="https://view.monday.com/embed/5400633560-504c802068f8b3e3a93a3ddb9456692c?r=use1"
      width="100%"
      height="90%"
    ></iframe>
  )
}
